/**
 * 워크스페이스 대시보드 카드 정의 (단일 목록)
 * — 새 카드는 여기 항목만 추가하면 됩니다.
 * — 대시보드에는 eligibility + admin_user.workspace_perms(백엔드)로 표시 여부가 결정됩니다.
 *
 * eligibility(ctx): 승인된 사용자 기준. 미반환 시 항상 노출 가능으로 간주.
 * ctx: { isSuper, myLevel }
 */

export const DASHBOARD_CARD_REGISTRY = [
  {
    id: 'attendance',
    title: '출퇴근 체크',
    description: 'GPS 위치와 함께 출퇴근을 기록하고 확인합니다',
    icon: '🕐',
    kind: 'route',
    path: '/attendance',
    defaultVisible: true,
  },
  {
    id: 'vehicle-operation',
    title: '차량운행',
    description: '차량 예약 후 운행시작·운행종료 km로 주행거리를 기록합니다',
    icon: '🚗',
    kind: 'route',
    path: '/vehicle-operation',
    defaultVisible: true,
    bypassWorkspacePerms: true,
    eligibility: ({ isSuper, isApproved, permissions }) =>
      isSuper || (isApproved && (permissions || []).some((p) => ['read', 'write', 'admin'].includes(p))),
  },
  {
    id: 'internal-training',
    title: '사내교육 이수',
    description: '사내교육 동영상 시청 · 진행률 자동 기록 · 이수 완료',
    icon: '📚',
    kind: 'route',
    path: '/internal-training',
    defaultVisible: true,
  },
  {
    id: 'schedule',
    title: '일정보기',
    description: '현장 일정 및 위치를 지도에서 확인하세요',
    icon: 'koreaMap',
    kind: 'route',
    path: '/schedule',
    defaultVisible: true,
  },
  {
    id: 'erp',
    title: 'ERP',
    description: 'ERP 화면으로 이동합니다',
    icon: '🏢',
    kind: 'route',
    path: '/erp',
    defaultVisible: true,
  },
  {
    id: 'google-chat',
    title: '구글 챗',
    description: 'Google Chat을 새 탭에서 엽니다 (회사 Workspace 계정)',
    icon: '💬',
    kind: 'external',
    url: 'https://chat.google.com/',
    defaultVisible: true,
    // 승인된 사용자는 메뉴 권한과 무관하게 항상 표시
    bypassWorkspacePerms: true,
    eligibility: ({ isSuper, isApproved }) => isSuper || !!isApproved,
  },
  {
    id: 'receipt',
    title: '영수증 등록',
    description: '영수증을 촬영해 OCR로 인식하고 주유비·식비 등 경비를 등록합니다',
    icon: '🧾',
    kind: 'route',
    path: '/receipt',
    defaultVisible: true,
  },
  {
    id: 'my-salary-leave',
    title: '급여명세서 및 연차',
    description: '급여·연차 관련 화면으로 이동합니다',
    icon: '💰',
    kind: 'route',
    path: '/my-salary-leave',
    defaultVisible: true,
  },
  {
    id: 'approval-inbox',
    title: '내 결재',
    description: '나에게 올라온 결재 대기를 대시보드에서 처리합니다',
    icon: '📥',
    kind: 'embed',
    defaultVisible: true,
  },
  {
    id: 'user-admin',
    title: '사용자 관리',
    description: '가입요청 승인 및 권한을 설정합니다',
    icon: '🗂️',
    kind: 'action',
    action: 'groupManage',
    defaultVisible: true,
    eligibility: ({ isSuper, myLevel }) => isSuper || (myLevel != null && myLevel <= 2),
  },
  {
    id: 'feature-permissions',
    title: '기능 권한 관리',
    description: '메뉴별 세부 기능 권한을 정의하고 사용자에게 부여합니다',
    icon: '🔐',
    kind: 'route',
    path: '/feature-permissions',
    defaultVisible: true,
    eligibility: ({ isSuper, myLevel }) => isSuper || (myLevel != null && myLevel <= 2),
  },
  {
    id: 'allowed-groups',
    title: '로그인 허용 그룹',
    description: '이 그룹에 속한 Google Workspace 멤버만 로그인·가입 신청할 수 있습니다',
    icon: '🔒',
    kind: 'action',
    action: 'autoApproveGroups',
    defaultVisible: true,
    eligibility: ({ isSuper, myLevel }) => isSuper || (myLevel != null && myLevel <= 2),
  },
  {
    id: 'notifications',
    title: '공지 푸시 발송',
    description: '앱이 설치된 전체 직원에게 푸시 알림을 보냅니다',
    icon: '📢',
    kind: 'route',
    path: '/notifications',
    defaultVisible: true,
    eligibility: ({ isSuper, myLevel }) => isSuper || (myLevel != null && myLevel <= 2),
  },
  {
    id: 'my-notifications',
    title: '내 알림 내역',
    description: '수신된 공지 알림 목록을 확인하고 읽음 처리합니다',
    icon: '🔔',
    kind: 'route',
    path: '/my-notifications',
    defaultVisible: true,
  },
  {
    id: 'dashboard-notice',
    title: '공지 보기',
    description: '대시보드 상단 공지 배너를 표시합니다',
    icon: '📣',
    kind: 'embed',
    defaultVisible: true,
  },
  {
    id: 'dashboard-training-incomplete',
    title: '미이수 교육자',
    description: '대시보드에 사내교육 미이수자(이름) 목록을 표시합니다',
    icon: '⚠️',
    kind: 'embed',
    defaultVisible: true,
  },
  {
    id: 'dashboard-leave',
    title: '다가오는 휴가',
    description: '대시보드에 이번 달 다가오는 휴가 일정을 표시합니다',
    icon: '🌴',
    kind: 'embed',
    defaultVisible: true,
  },
];
